import firebase from 'firebase/compat/app';
import 'firebase/compat/functions';

/**
 * Custom domains fronting the Cloud Functions with a Google load balancer + Cloud Armor. Projects not
 * listed keep using the default cloudfunctions.net URLs.
 */
const FUNCTIONS_CUSTOM_DOMAIN: Readonly<Record<string, string>> = {
  'nerva-dev': 'https://api-dev.mindsethealth.com',
  'ibs-app-d4d2a': 'https://api.mindsethealth.com',
};

/**
 * Functions instance for the current Firebase project, routed via the custom domain when one exists.
 * The project id comes from the same env var FirebaseSetup uses for both configs.
 */
export function functionsModule(): firebase.functions.Functions {
  return firebase.app().functions(FUNCTIONS_CUSTOM_DOMAIN[process.env.REACT_APP_PROJECT_ID ?? '']);
}
